import { render, staticRenderFns } from "./grid-menu.vue?vue&type=template&id=4442bb31&scoped=true&"
import script from "./grid-menu.vue?vue&type=script&lang=js&"
export * from "./grid-menu.vue?vue&type=script&lang=js&"
import style0 from "./grid-menu.vue?vue&type=style&index=0&id=4442bb31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4442bb31",
  null
  
)

export default component.exports